import { getColor2List, getProductOptionList } from '@/api/pmc/product';

const pmc = {
  state: {
    optionList: '',
    color2List: ''
  },

  mutations: {
    SET_OPTION_LIST: (state, optionList) => {
      state.optionList = optionList;
    },
    SET_COLOR2_LIST: (state, color2List) => {
      state.color2List = color2List;
    }
  },

  actions: {
    // 获取Color2列表
    initColor2List({ commit, state }) {
      return getColor2List()
        .then((resp) => resp.data)
        .then((data) => {
          console.log('color2, data:', data);
          commit('SET_COLOR2_LIST', data);
        });
    },
    // 获取 Option 列表
    initOptionList({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((response) => {
            const data = response.data;
            if (data.roles && data.roles.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit('SET_ROLES', data.roles);
            } else {
              reject('getInfo: roles must be a non-null array !');
            }
            commit('SET_NAME', data.username);
            commit('SET_USER_ID', data.userId);
            commit('SET_AVATAR', data.icon);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }
};

export default pmc;



// WEBPACK FOOTER //
// ./src/store/modules/pmc.js